import React from 'react'

export default function Header() {
  return (
<div
    style={{width:"100%",height:"10vh", display:"flex",alignItems:"center", 
justifyContent: "center", possition:"fixed"
  
  }}
    >
      <p style={{color:"white", fontWeight:"600",fontSize:"18px"}}>Highlight Text And Array</p>
    </div>
  )
}





 
